import { getRoundedNumber } from '../../../../../shared/utils/mathUtils';
import { RecipeMacros } from '../../../../interfaces/RecipeMacros';
import { INGREDIENT_ROUNDING_PRECISION } from '../../constants/recipeMacros';
import {
  IngredientDetailsFormValues,
  IngredientDetailsModalMode,
} from '../../interfaces/IngredientDetailsFormValues';
import { RecipeIngredientFormValue } from '../../interfaces/RecipeFormValues';
import { pickMacros } from '../measurementToUnitMacros/measurementToUnitMacros';

const getUnitMacros = (
  ingredient: RecipeIngredientFormValue,
  amountUnit: string,
): RecipeMacros => {
  // the current unit keeps the ingredient's own values - `measurements` may not list it
  const measurement =
    amountUnit !== ingredient.amountUnit &&
    ingredient.measurements.find(({ unit }) => unit === amountUnit);

  return measurement ? pickMacros(measurement) : ingredient.perUnit;
};

const cupsToPerUnit = (
  { isVegetable, veggiesCups }: IngredientDetailsFormValues,
  amount: number,
): number =>
  isVegetable && amount > 0
    ? getRoundedNumber((veggiesCups || 0) / amount, INGREDIENT_ROUNDING_PRECISION)
    : 0;

/** Modal Save, as a copy. In add mode the typed cups are a total for the amount; edit mode has no veggies input. */
export const ingredientFromModal = (
  ingredient: RecipeIngredientFormValue,
  modalValues: IngredientDetailsFormValues,
  mode: IngredientDetailsModalMode,
): RecipeIngredientFormValue => {
  const amount = modalValues.amount || 0;
  const perUnit = getUnitMacros(ingredient, modalValues.amountUnit);
  const veggies = mode === 'add' ? cupsToPerUnit(modalValues, amount) : perUnit.veggies;

  return {
    ...ingredient,
    amount,
    amountUnit: modalValues.amountUnit,
    perUnit: { ...perUnit, veggies },
  };
};
